/* APLB — barre d'achat fixe : visible seulement quand le bouton principal
   est sorti de l'écran, et suit le prix affiché en page. */
(function () {
  if (customElements.get('aplb-sticky-buy')) return;

  class AplbStickyBuy extends HTMLElement {
    connectedCallback() {
      var section = this.dataset.section;
      this.priceEl = this.querySelector('[data-sticky-price]');
      var buttons = document.getElementById('ProductSubmitButton-' + section)
        || document.querySelector('#product-form-' + section + ' .product-form__buttons')
        || document.querySelector('.product-form__buttons');
      if (!buttons || typeof IntersectionObserver === 'undefined') {
        this.hidden = false;
        return;
      }
      var self = this;
      this.io = new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        // Sous le bouton principal ou au-dessus : on montre la barre dès qu'il n'est plus visible.
        self.hidden = visible;
        document.body.classList.toggle('aplb-sticky-active', !visible);
      }, { threshold: 0 });
      this.io.observe(buttons);
      this.watchPrice(section);
      this.mirrorState(document.getElementById('ProductSubmitButton-' + section));
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.mo) this.mo.disconnect();
      if (this.stateObserver) this.stateObserver.disconnect();
      document.body.classList.remove('aplb-sticky-active');
    }

    mirrorState(main) {
      var own = this.querySelector('.aplb-sticky__button');
      if (!main || !own || typeof MutationObserver === 'undefined') return;
      var sync = function () {
        if (main.hasAttribute('disabled')) own.setAttribute('disabled', '');
        else own.removeAttribute('disabled');
        // Dawn signale l'envoi en cours par aria-disabled et la classe
        // loading : le bouton fixe doit montrer la meme chose, sinon le
        // client tape deux fois.
        var busy = main.getAttribute('aria-disabled') === 'true';
        own.setAttribute('aria-disabled', busy ? 'true' : 'false');
        var loading = main.classList.contains('loading');
        own.classList.toggle('loading', loading);
        // .button.loading rend le texte transparent : sans demasquer la
        // roue, le bouton fixe serait vide pendant l'ajout au panier.
        var spinner = own.querySelector('.loading__spinner');
        if (spinner) spinner.classList.toggle('hidden', !loading);
      };
      this.stateObserver = new MutationObserver(sync);
      this.stateObserver.observe(main, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class'],
      });
      sync();
    }

    watchPrice(section) {
      var source = document.getElementById('price-' + section);
      if (!source || !this.priceEl || typeof MutationObserver === 'undefined') return;
      var self = this;
      var sync = function () {
        var node = source.querySelector('.price__sale .price-item--sale') || source.querySelector('.price-item--regular');
        if (node) self.priceEl.textContent = node.textContent.trim();
      };
      this.mo = new MutationObserver(sync);
      this.mo.observe(source, { childList: true, subtree: true, characterData: true });
      sync();
    }
  }

  customElements.define('aplb-sticky-buy', AplbStickyBuy);
})();
